<div class="modal-header b pb-0 pt-4 px-5">
  <h5 class="modal-title f-16 text-defualt" id="createnote">Log a call <span *ngIf="candidate?.firstname || candidate?.lastname" >for <span class="text-capitalize" > 
    {{candidate?.firstname}} {{candidate?.lastname}} </span> </span> </h5>
  <button data-testid="auto-app-call-log-button-1" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body px-5">
  <!-- <div class="row mb-1" *ngIf="candidate?.firstname || candidate?.lastname">
    <div class="col-md-12">
      
      <p class="gray-text f-12"> {{candidate?.personalemail}}</p>
    </div>
  </div> -->
  <div class="row mb-3">
    <div class="col-md-8">
      <label for="outcome">Outcome<span class="text-danger">*</span></label>
      <div class="position-relative d-flex">
        <select data-testid="auto-app-call-log-select-1" class="wc-form-control nobg" [(ngModel)]="selectedOutcome" (change)="outcomeselected(outcome.value)"
          #outcome >
          <option value="null" disabled>Select outcome type</option>
          <option [value]="outcome.outcomeid" *ngFor="let outcome of outcomeslist">{{outcome?.outcometext}}</option>
        </select>
        <span class="selectdrop-down position-absolute tr-n f-12 mt-3 mr-2"><i
          class="fas fa-chevron-down"></i></span>
      </div>
    </div>
  </div>
  <div *ngIf="outcomeError" class="row error_message mb-3">
    <div class="col-md-12 ml-4 ">
      <label>Please choose a reason</label>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col">
      <label for="Notes">Call note<span class="text-danger"></span></label>
      <textarea data-testid="auto-app-call-log-textarea-1" placeholder="Enter call note..." class="wc-textarea wc-form-control mb-4" rows="5" cols="10"
        [(ngModel)]="callnote"></textarea>
    </div>
  </div>
  <div *ngIf="callLogList?.length >0" class="row mb-3">
    <div class="col f-16 mt-4">
      Call Log History
    </div>
  </div>

  <div class="notesContainer" id="noteH" *ngIf="callLogList?.length >0">
    <div class="mb-3 mr-2" *ngFor="let calllog of callLogList">
      <div class="mb-1 d-flex justify-content-between">
        <!-- <span class="f-12 font-weight-500">
          {{calllog.firstname || ""}} {{calllog.lastname || ""}}<span *ngIf="calllog.designation != null"> -
            {{calllog.designation}}</span>
        </span> -->
        <span class='f-14 font-weight-500'>  {{calllog.outcometype}} - {{calllog.outcometext}} </span>
        <span class="gray-text f-12">
          {{calllog.createdon | date: 'dd MMM yyyy'}}
        </span>
      </div>
      <!-- <div class="mb-2 text-light-grey f-12">
        {{calllog.outcometype}} - {{calllog.outcometext}}
      </div> -->
      <div class="mb-2 f-14">
        {{calllog.callnote}}
      </div>

    </div>
  </div>

  <!-- <div *ngIf="(start == 2 && totalCallLogCounts > 2)" class="row mt-3">
      <div (click)="pagination()" class="col-md-12">
        <label class="anchor-text">
          view more ...
        </label>
      </div>
    </div>​ -->
</div>​
<div class="modal-footer b">
  <button data-testid="auto-app-call-log-button-2" type="button" class="btn-trms-small" data-dismiss="modal" *ngIf='!isEdit'
    (click)="createCallLog()">Save</button>
  <button data-testid="auto-app-call-log-button-3" type="button" *ngIf="isEdit" class="btn-trms-small" data-dismiss="modal"
      (click)="editCallLog()">Update</button>
</div>
​
<ng-template #errorModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-call-log-button-4" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-call-log-button-5" class="btn-trms-small" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
​
<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pl-1">
          <h5 class="modal-title f-16 text-defualt" id="createnote">Call Log </h5>
          <button data-testid="auto-app-call-log-button-6" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="mb-3 mt-1 f-14 SuccessBoxed d-flex">
          <i class="fas fa-check-circle ml-2 mr-5 pt-1 f-28"></i>
          <span class="f-14 mt-3 font-weight-500"> Call Log Succesfully Added </span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col pl-1">
          <p class="f-14 font-weight-500">Update candidate pipeline status
            <i class="fas fa-info-circle text-dis" [ngbTooltip]="pipelineplaceHolder"
              placement="right"></i>
          </p>

          <ng-template #pipelineplaceHolder>
            <p> <span class="hot-dot mr-1"></span>Hot candidate </p>
            <p class="mr-3"> All Signs Point To “Go” </p>
            <p> <span class="warm-dot mr-1"></span>Warm candidate </p>
            <p class="mr-3"> Interested, But Not Ready,
              Able Or A Good Fit
            </p>
            <p> <span class="cold-dot mr-1 "></span>Cold candidate </p>
            <p class="mr-3"> Casual Contacts and Candidates
              For Re-engagement
            </p>
          
          </ng-template>


          <p class="f-12">Pipeline Status <span class="text-danger">*</span></p>
          <span class="position-relative mb-1 d-flex col-6 pl-0">
            <select data-testid="auto-app-call-log-select-2" class="nobg wc-form-control pipeline-text-border" [(ngModel)]="talentvalue">
              <option value="null" disabled selected>Select</option>
              <option *ngFor="let status of pipeline_list" [value]="status"> {{status}} Candidate </option>
          </select>
            <span class="selectdrop-down position-absolute f-12 mt-3 mr-5 tr-x"> <i
                class="fas fa-chevron-down"></i></span>
          </span>
          <p class="text-danger f-12">
            {{talentErrorMessage}}
        </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-call-log-button-7" class="btn-trms-small" (click)="SaveTalent();">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>